import { render, staticRenderFns } from "./billingTerms.vue?vue&type=template&id=cca55c5c&scoped=true"
import script from "./billingTerms.vue?vue&type=script&lang=js"
export * from "./billingTerms.vue?vue&type=script&lang=js"
import style0 from "./billingTerms.vue?vue&type=style&index=0&id=cca55c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca55c5c",
  null
  
)

export default component.exports